var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireFlameSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.113 4.365C196.937 -1.456 187.058 -1.454 180.879 4.364C74.519 104.508 0 234.137 0 312C0 437.945 79 512 192 512S384 437.945 384 312C384 233.902 309.032 104.166 203.113 4.365ZM192 432C135.5 432 96 394.239 96 340.259C96 327.793 100.207 284.941 179.868 197.215C186.181 190.262 197.819 190.262 204.132 197.215C283.793 284.941 288 327.793 288 340.259C288 394.239 248.5 432 192 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireFlameSimple);
export default __webpack_public_path__ + "static/media/fire-flame-simple.39eae046ec9665890ae7948372df4346.svg";
export { ForwardRef as ReactComponent };